import axios from "axios";
import { attachAuthInterceptor } from "./authInterceptor";

const bodycamClient = axios.create({
  baseURL: import.meta.env.VITE_BODYCAM_API_DOMAIN,
  headers: { "Content-Type": "application/json" },
});

attachAuthInterceptor(bodycamClient);

export default bodycamClient;
